module.exports = __webpack_public_path__ + "img/norway.74a3e811.svg";